<template>
  <div class="popup-wp" @click.self="closePopup">
    <div class="box">
      <div class="box-content">
        <fai class="icon" icon="times" @click="closePopup()"></fai>
        <custom-title :content="content" color="white"></custom-title>
        <vue-markdown v-html="content.text" class="markdown"></vue-markdown>
        <router-link :to="content.link.cached_url">
          <img :src="content.img" alt="popup image">
        </router-link>
        <custom-btn class="btn" :link="content.link">{{$t("message.more")}}</custom-btn>
      </div>
    </div>
  </div>
</template>

<script>
import VueMarkdown from "vue-markdown";

export default {
  components: {
    VueMarkdown
  },
  props: {
    content: null
  },
  methods: {
    closePopup(event) {
      //event.stopPropagation();
      this.$store.commit("CLOSE_POPUP");
    }
  }
};
</script>

<style lang="scss">
.popup-wp {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 99999;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  .box {
    background-color: white;
    border-radius: 10px;
    position: relative;
    height: auto;
    max-height: 80vh;
    width: 800px;
    max-width: 90%;
    overflow: auto;
    padding-bottom: 30px;
    box-shadow: 1px 1px 11px 9px rgba(0, 0, 0, 0.23);
    .box-content {
      display: flex;
      flex-direction: column;
      position: relative;
      img {
         margin:35px auto;
      }
      .icon {
        position: absolute;
        right: 15px;
        top: 12px;
        font-size: 25px;
        color: $primary;
        cursor: pointer;
        transition: transform 0.4s ease-in-out;
        transform: scale(1);
        &:hover {
          transform: scale(1.2);
        }
      }
      .custom-title {
        width: 100%;
      }
      .markdown {
        text-align: center;
       
      }
    }
  }
  .btn {
    text-align: center;
  }
}
</style>
